import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";

export type DropdownMenuContentProps = ComponentProps<typeof DropdownMenuPrimitive.Content>;

export const Content = ({ ref, className, sideOffset = 4, ...props }: DropdownMenuContentProps) => (
  <DropdownMenuPrimitive.Portal>
    <DropdownMenuPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "relative z-50 flex min-w-[240px] flex-col gap-1 rounded-lg border border-neutral-96 bg-white p-2 shadow-lg",
        `data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95`,
        "max-h-(--radix-dropdown-menu-content-available-height) overflow-x-hidden overflow-y-auto",
        className
      )}
      {...props}
    />
  </DropdownMenuPrimitive.Portal>
);

Content.displayName = DropdownMenuPrimitive.Content.displayName;
